
const ClientRevData = [
  {
    id: 1,
    userName: "Jordan Banks",
    img: "",
    totalRev: "3 reviews",
    date: "May 31, 2024",
    bodyTitle: "Claims solution scotland were superb",
    bodyDesc:
      "Claims solution scotland were superb, handled my claim quickly and efficiently, they passed it to the right people and I was delighted with the outcome ",
    expDate: "August 28, 2023",
    rating: 5,
  },
  {
    id: 2,
    userName: "S Campbell",
    img: "",
    totalRev: "1 reviews",
    date: "Dec 9, 2020",
    bodyTitle: "Service review",
    bodyDesc:
      "I found the staff to be extremely helpful. They where always available to answer any calls or questions which i had and their level of customer service was second to none. They left no stone unturned in order to get the best possible outcome for myself which was a massive help. I would happily recommend to any friends or family who may need to use the service.",
    expDate: "December 09, 2020",
    rating: 5,
  },

  {
    id: 3,
    userName: "Shannon Osprey",
    img: "",
    totalRev: "1 reviews",
    date: "Jun 8, 2024",
    bodyTitle: "they were really supportive and very…",
    bodyDesc: "they were really supportive and very helpful ",
    expDate: "August 28, 2023",
    rating: 5,
  },
  {
    id: 4,
    userName: "Tim S",
    img: "",
    totalRev: "1 reviews",
    date: "Nov 3, 2020",
    bodyTitle: "Great firm, great guys. Very happy to recommend.",
    bodyDesc:
      "Great firm. Great guys. You'll get a top-notch service from Claim Solutions Scotland. They'll take care of you, just as they've taken care of me. They're honest, hard working, professional and competent. They'll have your best interests at heart and I'm very happy to recommend them; especially John, William, Agnes & Daniel.",
    expDate: "November 02, 2020",
    rating: 5,
  },

  {
    id: 5,
    userName: "Dan",
    img: "",
    totalRev: "1 reviews",
    date: "Jan 8, 2023",
    bodyTitle: "Easy, Convenient, Quick",
    bodyDesc:
      "My experience with claims solutions Scotland was nothing but positive. From the start Agnes was attentive, knowledgeable and made me feel at ease about the process. I didn’t have to do any travelling to meetings or appointments etc as everything was done over the phone so the whole process is extremely convenient. I highly recommend claims solutions Scotland and I would be happy to use their services again in future.",
    expDate: "February 14, 2022",
    rating: 5,
  },
  
  {
    id: 8,
    userName: "customer",
    img: "",
    totalRev: "7 reviews",
    date: "Mar 29, 2020",
    bodyTitle: "I highly recommend Claims Solutions",
    bodyDesc:
      "I highly recommend Claims Solutions. The communication was first class, always keeping me upto date with any change in the claim & they were very approachable, answered all the questions I had & ensured that i felt comfortable asking any questions during the whole process. I was over the moon with the outcome of my claim & it was all dome pretty quickly. Thanks again .",
    expDate: "March 28, 2020",
    rating: 5,
  },
  {
    id: 9,
    userName: "Ian Irvine",
    img: "",
    totalRev: "10 reviews",
    date: "May 10, 2023",
    bodyTitle: "Great Company!",
    bodyDesc:
      "This company are always professional and helpful and they take ownership all the way through! Special mention for Louise Mee who always goes above and beyond.......lierally, nothing is too much trouble for her.......thanks Louise!",
    expDate: "May 10, 2023",
    rating: 5,
  },
  
];
export { ClientRevData };
